import type { QueryClient } from '@tanstack/react-query';

// 内容（笔记/剪藏/知识单元等）变更后需要全局失效的 queryKey 前缀：
// 列表页 + 聚合视图（pipeline/emergence/brain 统计）+ 标签体系
// 注意 queryKey 匹配是数组逐元素前缀：'graphify' 匹配不到 'graphify-status'
// 这类连字符单元素 key，graphify-*/wiki-* 必须逐条列全；工作台键形是裸多元素
// （['workbench', ...]/['graphify', 'graph', ...]/['wiki', 'topics', ...]），与连字符
// 键两轨并存、互不匹配，两边都要在表里（10-11 审查实捕：只列连字符一边时
// content-version 准实时刷新覆盖不到首页工作台）。
// email-*/social-* 不在表内是刻意：后端 content-version 戳只聚合
// Note/BrowserClip/KnowledgeUnit/Document/Tag/Folder（site_knowledge.content_version），
// 邮件/社媒表不动戳，列了也刷不到。
const CONTENT_QUERY_PREFIXES = ['notes', 'clips', 'read-later', 'knowledge', 'capsules', 'documents', 'rss-feeds', 'rss-entries', 'tags', 'tag-associations', 'pipeline', 'emergence', 'brain', 'chat', 'folders', 'sticky-notes', 'reminders', 'embodied', 'graph-bridges', 'graph-tag-network', 'graphify-status', 'graphify-graph', 'graphify-physical-graph', 'graphify-report', 'graphify-build-estimate', 'graphify-auto-evolve', 'wiki-topics', 'wiki-entries', 'wiki-entry', 'wiki-lint', 'cognitive', 'jianghu', 'attention', 'knowledge-top-invoked', 'knowledge-recent-practiced', 'rss-auto-fetch', 'workbench', 'graphify', 'wiki', 'recycle-bin', 'wiki-deeplint-latest', 'wiki-entry-versions'];

export function invalidateContentQueries(queryClient: QueryClient): void {
  for (const key of CONTENT_QUERY_PREFIXES) {
    // refetchType 默认 active（09-14 云端卡顿实捕：'all' 会把 42 路前缀的全部缓存
    // 查询——包括没挂载的页面——立刻重取，单 worker 后端被失效风暴打满，
    // 保存一次笔记列表 5 秒才刷新）。active 只重取正在挂载的查询，未挂载的
    // 标记 stale、下次进页面时才重取——失效语义不变，风暴消失。
    queryClient.invalidateQueries({ queryKey: [key] });
  }
}
